<span class="value bold-text">{{ value }}</span>
<div class="bar-outer">
  <div class="bar-inner" [style.width.%]="value"></div>
</div>
